import { render, staticRenderFns } from "./ApprovalDesignForm.vue?vue&type=template&id=31997212&scoped=true&"
import script from "./ApprovalDesignForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalDesignForm.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDesignForm.vue?vue&type=style&index=0&id=31997212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31997212",
  null
  
)

export default component.exports